var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_setup.custom.loading),expression:"custom.loading"}],staticClass:"custom-overview"},[(_setup.customList.length)?_c(_setup.MobDocumentCard,{attrs:{"listData":_setup.customList,"showIcon":true},on:{"goDetail":_setup.handlePreview}}):_c('Empty')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }